<h3 mat-dialog-title [kitText]="titleText"></h3>
<div mat-dialog-content>
  <kit-bs-checkbox *ngFor="let employeeField of employeeFields" [kitModel]="employeeField"></kit-bs-checkbox>
</div>
<div mat-dialog-actions>
  <kit-bs-button [kitModel]="cancelAction"></kit-bs-button>
  <kit-bs-button [kitModel]="confirmAction"></kit-bs-button>
</div>
